import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MeasureView from './MeasureView';
import RankView from './RankView';
import { Grid } from "@material-ui/core";
import Card from "./Card/Card.jsx";
import CardHeader from "./Card/CardHeader";
import CardBody from "./Card/CardBody";
import CardIcon from "./Card/CardIcon";
import Tasks from "./Tasks/Tasks.jsx";
import { AccountCircle, ExitToApp, CreditCard, Web, Feedback } from '@material-ui/icons';

const styles = theme => ({
  card: {
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
    width: '100%'
  },
  cardCategory: {
    color: "#999999",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    paddingBottom: "10px",
    marginBottom: "0"
  },
});

let demoMessages = [
  { messageText: "Consider adding different paths from the page to high value content, with the call to action written in context of the page content." },
  { messageText: "Consider optimizing the page further.  Current personalization is not working optimally." },
  //{ messageText: "Consider testing different call to actions and then expand personalization." }
];

function getPersonalizedComponentCount(item) {
  //TODO: this needs to handle final renderings
  let s = new Set(item.personalizationDetails.renderingRulesets.map(e => e.renderingId));
  return Array.from(s).length;
}

const ItemDetails = ({ classes, analytics, content, paths, pageVisitHistory, pageVersionHistory, recommendations }) => (
  <div className={classes.root}>
    <Grid container spacing={8}>
      <Grid item xs={12} sm={4} md={3}>
        <MeasureView label="Visits" format="0,0.0 a" subheader="total visits" value={analytics.visits} icon={(<Web />)} />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <MeasureView label="Value" format="0,0.0 a" subheader="engagement value" value={analytics.value} icon={(<CreditCard />)} />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <MeasureView label="Bounce Rate" format="0%" subheader="bouncy-bounce, lost visitors" value={analytics.bounceRate} icon={(<ExitToApp />)} />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <MeasureView label="Personalization" subheader="personalized spots"
          value={getPersonalizedComponentCount(content)}
          shouldDisplayWarning={v => v <= 2}
          icon={(<AccountCircle />)} />
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={8}>
      <Grid item xs={6} sm={6} md={6}>
        <Card>
          <CardHeader color="info" stats icon>
            <CardIcon color="info">
              <Feedback />
            </CardIcon>
            <p className={classes.cardCategory}>Recommendations</p>
            <h3 className={classes.cardTitle}>
              {demoMessages.length}
            </h3>
          </CardHeader>
          <CardBody>
            <Tasks tasks={demoMessages} getTaskText={(t) => t.messageText}></Tasks>
          </CardBody>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>

        {/* experience page is 82 */}
        <RankView id='valueIdx' gaugeWidth={150} gaugeHeight={190}
          label="Value Index"
          stats={{
            ranking: {
              value: analytics.valueIndex,
              targetValue: 100,
              fromAverage: 32.4
            },
            primaryMetric: {
              title: "VpV",
              value: 2.02,
              subheader: "Value per Visit"
            }
          }} />
      </Grid>
      {/* experience page is 4 */}
      <Grid item xs={3} sm={3} md={3}>
        <RankView id='visitorIdx' gaugeWidth={150} gaugeHeight={190}
          label="Visitor Index"
          stats={{
            ranking: {
              value: analytics.visitIndex,
              targetValue: 100,
              fromAverage: 14.4
            },
            primaryMetric: {
              title: "VpV",
              value: 4.02,
              subheader: "Value per Visit"
            }
          }} />
      </Grid>
    </Grid>
  </div>
);

export default withStyles(styles)(ItemDetails);



// WEBPACK FOOTER //
// ./src/components/ItemDetails.js